export default __webpack_public_path__ + "static/media/category3.e56e026e.png";